//include 4 
jQuery(function(){
    var template = `<div class="modal">
            <div class="row">
                <div class="columns large-12">
                    <% if(!!title){ %>
                        <h2 class="capital-blue"><%= title %></h2>
                    <% } %>
                    <% if(!!message){ %>
                        <p><%= message %></p>
                    <% } %>
                </div>
            </div>
        </div>`;

    var lityInstance = null;
    var compiled = _.template(template);

    var privateFunctions = {
        open(message,title){
            title = title || null;
            var html = compiled({
                message:message,
                title:title
            });
            if(typeof html == "function")
                html = html({
                message:message,
                title:title
            });
            if(lityInstance != null){
                lityInstance.close();
            }
            lityInstance = lity(html);
            return lityInstance;
        },
        close(){
            if(lityInstance != null){
                lityInstance.close();
                lityInstance = null;
            }
        }
    };

    window.pixelpoint.modal = {
        open:privateFunctions.open,
        close:privateFunctions.close
    };
});